import * as React from 'react';
import * as style from './style.css';

interface IMarkedListItemProps {
  text: string;
}

export const MarkedListItem = ({ text }: IMarkedListItemProps) => {
  return <li className={style['seo-li']}>{text}</li>;
};
